/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-FocusZoneDisabledExample .ms-Row{display:block;margin:5px}.ms-FocusZoneDisabledExample-textField{display:inline-block;width:300px}"}]);
/* tslint:enable */
